import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      bs: {
        translation: {
          "Get Free Spot Recommendations Now": "Dobij besplatne preporuke lokacija odmah",
          "Recommendations": [
            "🍯 Trebinje: Šume akacije pune nektara",
            "🌻 Konjic: Idealni uslovi za livadski med",
            "🌸 Stolac: Smokve i nar dodaju raznovrstan polen",
            "🌿 Prozor-Rama: Planinske livade u punom cvatu",
            "🍃 Foča: Čiste rijeke i ljekovito bilje privlače pčele",
            "🌸 Nevesinje: Djetelina i divlje cvijeće bogate nektarom",
            "🌿 Bugojno: Jake akacije i kesten livade",
            "🍯 Ljubuški: Mediteransko bilje u punom cvatu",
            "🌻 Glamoč: Lipov med sa mirisom",
            "🌿 Kupres: Alpske livade pune divljeg cvijeća",
            "🍯 Čapljina: Cvjetovi citrusa pojačavaju aromu meda",
            "🌸 Posušje: Kadulja i timijan na krškim tlima",
            "🍃 Livno: Široke livade idealne za livadski med",
            "🌿 Grude: Ljekovito bilje u cvatu privlači pčele",
            "🌻 Široki Brijeg: Polja lavande i djeteline u cvatu",
            "🍯 Jajce: Planinsko bilje stvara bogat okus meda",
            "🌸 Rudo: Čisto okruženje idealno za divlji med"
          ],
          "Preview Mode": "Preview Mode:",
          "Sign up to see all →": "Registruj se da vidiš sve →",
          "Get Weekly Map Recommendations Based on Real Data": "Dobij sedmične preporuke lokacija zasnovane na stvarnim podacima",
          "Each week, we analyze weather, blooming timing, and more — so you know exactly where to place your hives.":
            "Svake sedmice analiziramo vremenske uvjete, period cvjetanja i još mnogo toga — tako da tačno znaš gdje postaviti košnice.",
          "Optimal Locations Map": "Prikaz optimalnih lokacija",
          "Location Info": "Informacije o lokaciji",
          "Weather Data": "Podaci o vremenu",
          "Top 5 Cities": "Top 5 gradova",
          "Why HoneyScout Changes Everything": "Zašto HoneyScout mijenja sve",
          "Why Now?": "Zašto sada?",
          "Climate patterns are shifting - traditional spots may no longer be optimal":
            "Klimatski obrasci se mijenjaju - tradicionalna mjesta više možda nisu optimalna",
          "AI-powered analysis gives you the competitive edge in honey production":
            "Analiza vođena AI daje ti konkurentsku prednost u proizvodnji meda",
          "Real-time data prevents costly mistakes and maximizes your investment":
            "Podaci u realnom vremenu sprečavaju skupe greške i maksimiziraju tvoju investiciju",
          "How It's Implemented": "Kako je implementirano",
          "Real-time Weather Analysis": "Analiza vremenskih podataka u realnom vremenu",
          "Advanced meteorological data processing for precise forecasts":
            "Napredna obrada meteoroloških podataka za precizne prognoze",
          "Blooming Pattern Recognition": "Prepoznavanje obrazaca cvjetanja",
          "AI identifies optimal flowering cycles across regions":
            "AI identifikuje optimalne cikluse cvjetanja u različitim regionima",
          "Smart Location Scoring": "Pametno ocjenjivanje lokacija",
          "Multi-factor algorithm ranks best placement opportunities":
            "Algoritam sa više faktora rangira najbolje mogućnosti za postavljanje",
          "HoneyScout": "HoneyScout",
          "Your AI-Powered Beekeeping Companion": "Tvoj AI-podržani pčelarski pomoćnik",
          "Recommendation": "Preporuke",
          "Login with Email": "Ulogujte se sa Emailom",
          "Please enter valid email!": "Molimo vas unesite validan email!",
          "Please enter email!": "Molimo unesite email!",
          "Error sending verification email.": "Greška prilikom slanja verifikacijskog emaila.",
          "Verification email sent! Please check your inbox.": "Verifikacijski email poslan, molimo provjerite inbox.",
          "Welcome": "Dobrodošli",
          "Honeyscout — This week's new prediction.": "Honeyscout - ovosedmična predikcija.",
          "Bosnia": "BiH",
          "Croatia": "Hrvatska",
          "Serbia": "Srbija",
          "Top 5 in": "Najboljih 5 u",
          "Image of the weather": "Slika vremena",
          "Temperature": "Temperatura",
          "Top 3 Plants Blooming": "Tri biljke u cvatu",
          "Log out": "Odjavi se",
          "Register": "Registracija",
          "Log in": "Prijava",
          "Email": "Email",
          "Password": "Lozinka",
          "Already have an account?": "Već imate račun?",
          "Don't have an account?": "Nemate račun?",
          "Registration successful! Redirecting to login...": "Registracija uspješna! Preusmjeravanje na prijavu...",
          "Login failed": "Prijava nije uspjela",
          "Failed to register": "Registracija nije uspjela",
          "Select a location to view blooming data": "Izaberite lokaciju da vidite biljke u cvatu",
          "Select a location to view weather data": "Izaberite lokaciju da vidite podatke o vremenu",
          "Chestnut": "Kesten",
          "Goldenrod": "Zlatnica",
          "Heather": "Vrijesak",
          "Rosemary": "Ruzmarin",
          "Lavender": "Lavanda",
          "Wild Thyme": "Divlji timijan",
          "Ivy": "Bršljan",
          "Sage": "Žalfija",
          "Dandelion": "Maslačak",
          "Linden": "Lipa",
          "Clover": "Djetelina",
          "Sunflower": "Suncokret",
          "Buckwheat": "Heljda",
          "Acacia": "Akacija",
          "few clouds": "Malo oblačno",
          "clear sky": "Vedro",
          "rain": "Kiša",
          "Wind": "Vjetar",
          "Rain": "Padavine",
          "scattered clouds": "Raspršeni oblaci",
          "broken clouds": "Pretežno oblačno",
          "shower rain": "Pljusak",
          "thunderstorm": "Grmljavina",
          "snow": "Snijeg",
          "mist": "Magla",
          "overcast clouds": "Oblačno",
          "light rain": "Slaba kiša",
          "moderate rain": "Umjerena kiša",
          "heavy intensity rain": "Jaka kiša",
          "light snow": "Slab snijeg",
          "heavy snow": "Jak snijeg",
          "sleet": "Susnježica",
          "fog": "Magla",
          "haze": "Haze",
          "Wildflowers": "Poljsko cvijeće",
          "Meadow Plants": "Livadske biljke",
          "Thyme": "Majčina dušica",
          "Raspberry": "Malina",
          "Daisy": "Tratinčica",
          "Beech": "Bukva",
          "Spruce": "Smreka",
          "Fir": "Jela",
          "Pine": "Bor",
          "Wild Mint": "Divlja menta",
          "Rapeseed": "Uljana repica",
          "Current": "Trenutno",
          "Weather": "Vremenski uvjeti",
          "Satellite Metrics": "Satelitske metrike",
          "NDVI": "NDVI",
          "Soil Moisture": "Vlažnost tla",
          "Land Surface Temp (°C)": "Temperatura zemljišta (°C)",
          "Land Cover Type": "Tip pokrova zemljišta",
          "Select a location to view satellite metrics": "Odaberite lokaciju da vidite satelitske metrike",
          "Yarrow": "Stolisnik",
          "From": "od",
          "To": "do",
          "Weather Forecast": "Vremenska prognoza",
          "Select a location to view the forecast": "Odaberite lokaciju da vidite prognozu",
          "Top 3 Locations": "Top 3 lokacije",
          "Land Surface Temp": "Temperatura zemljišta",
          "7-Day Forecast": "7-dnevna prognoza",
          "Current Weather": "Trenutno vrijeme",
          "Wind Speed": "Brzina vjetra",
          "Humidity": "Vlažnost zraka",
          "Plants in Bloom": "Biljke u cvatu",
          "Welcome back": "Dobrodošli nazad",
          "Best locations for beekeeping": "Najbolje lokacije za pčelarenje",
          "Real-time data": "Real-time podaci",
          "Weather forecast for selected location": "Vremenska prognoza za odabranu lokaciju",
          "Current weather conditions": "Trenutni vremenski uvjeti",
          "Detailed weather information": "Detaljne vremenske informacije",
          "Currently blooming": "Trenutno cvjetanje",
          "Active blooming": "Aktivno cvjetanje",
          "Excellent": "Vrhunski",
          "Medium": "Srednji",
          "Low": "Niski",
          "Lowest temp": "Najniža temperatura",
          "Highest temp": "Najviša temperatura",
          "mm = rainfall": "mm = padavine",
          "Monday": "Ponedjeljak",
          "Tuesday": "Utorak",
          "Wednesday": "Srijeda",
          "Thursday": "Četvrtak",
          "Friday": "Petak",
          "Saturday": "Subota",
          "Sunday": "Nedjelja",
          "Mon": "Pon",
          "Tue": "Uto",
          "Wed": "Sri",
          "Thu": "Čet",
          "Fri": "Pet",
          "Sat": "Sub",
          "Sun": "Ned",
          "NDVI Explanation": "Vegetacijski indeks: 0 i ispod = nema vegetacije, 1 = bujna vegetacija",
          "Soil Moisture Explanation": "Indeks vlažnosti tla: niže vrijednosti = sušnije, više vrijednosti = vlažnije",
          "Land Surface Temp Explanation": "Temperatura površine zemlje: različita od temperature zraka",
          "Land Cover Explanation": "Tip zemljišta: šuma, poljoprivredno, urbano, voda itd.",
          "Learn more": "Saznaj više",
          "Real-time satellite data for vegetation, soil, and land conditions": "Real-time satelitski podaci za vegetaciju, tlo i uslove zemljišta",
          "bagrem": "Bagrem",
          "livada": "Livadski med",
          "kadulja": "Kadulja",
          "draca": "Drača",
          "kesten": "Kesten",
          "BiH": "Bosna i Hercegovina",
          "Srbija": "Srbija",
          "Hrvatska": "Hrvatska",
          "Zone radius": "Radijus zone",
          "Filter Locations": "Filtriraj lokacije",
          "Choose view type": "Odaberi tip prikaza",
          "Zones": "Zone",
          "locations found": "lokacija pronađeno",
          "No zones found for this plant": "Nema zona za ovu biljku",
          "Odlična aktivnost": "Odlična aktivnost",
          "Dobra aktivnost": "Dobra aktivnost",
          "Umjerena aktivnost": "Umjerena aktivnost",
          "Slaba aktivnost": "Slaba aktivnost",
          "Nema aktivnosti": "Nema aktivnosti",
          "Noćni mir": "Noćni mir",
          "Idealni uvjeti za pčele": "Idealni uvjeti za pčele",
          "Pčele rade normalno": "Pčele rade normalno",
          "Smanjen izlazak": "Smanjen izlazak",
          "Loši vremenski uvjeti": "Loši vremenski uvjeti",
          "Pčele u košnici": "Pčele u košnici",
          "Pčele spavaju": "Pčele spavaju",
          "Aktivnost pčela": "Aktivnost pčela",
          "vjetar": "vjetar",
          "Odaberi lokaciju za procjenu": "Odaberi lokaciju za procjenu",
          "Odaberi lokaciju na mapi": "Odaberi lokaciju na mapi",
          "Uslovi za pčele": "Uslovi za pčele",
          "Odlični uslovi": "Odlični uslovi",
          "Dobri uslovi": "Dobri uslovi",
          "Umjereni uslovi": "Umjereni uslovi",
          "Loši uslovi": "Loši uslovi",
          "Vrlo loši uslovi": "Vrlo loši uslovi",
          "Noćni uslovi": "Noćni uslovi",
          "Idealan period za pčele": "Idealan period za pčele",
          "Pčele aktivne i produktivne": "Pčele aktivne i produktivne",
          "Ograničena aktivnost": "Ograničena aktivnost",
          "Nepovoljno za pčele": "Nepovoljno za pčele",
          "Pčele ostaju u košnici": "Pčele ostaju u košnici",
          "Pčele miruju": "Pčele miruju",
          "Vremenski uslovi za pčele": "Vremenski uslovi za pčele",
          "BeeCare": "BeeCare",
          "Pratite košnicu uživo": "Pratite košnicu uživo",
          "Pametna vaga za pčelare": "Pametna vaga za pčelare",
          "BeeCare digitalni sistemi za pčelarstvo": "BeeCare digitalni sistemi za pčelarstvo",
          "Želite pratiti stanje svojih košnica u realnom vremenu?":
            "Želite pratiti stanje svojih košnica u realnom vremenu?",
            "Kliknite i naručite": "Kliknite i naručite",
            "Scale!": "vagu!",
          "Naruči": "NARUČI",
          "ZA PČELARSTVO": "ZA PČELARSTVO",
          "DIGITALNI SISTEMI": "DIGITALNI SISTEMI",
          "Znate li koliko vaša košnica zaista vrijedi? BeeCare pametna vaga mjeri težinu, temperaturu i vlagu — 24/7, direktno na vašem telefonu.":
            "Znate li koliko vaša košnica zaista vrijedi? BeeCare pametna vaga mjeri težinu, temperaturu i vlagu — 24/7, direktno na vašem telefonu."
        }
      },
      en: {
        translation: {
          "Get Free Spot Recommendations Now": "Get Free Spot Recommendations Now",
          "Recommendations": [
            "🍯 Trebinje: Acacia forests full of nectar",
            "🌻 Konjic: Ideal conditions for meadow honey",
            "🌸 Stolac: Fig and pomegranate adding diverse pollen",
            "🌿 Prozor-Rama: Mountain meadows in full bloom",
            "🍃 Foča: Pure rivers and medicinal herbs attract bees",
            "🌸 Nevesinje: Clover and wildflowers rich in nectar",
            "🌿 Bugojno: Strong acacia and chestnut pastures",
            "🍯 Ljubuški: Mediterranean herbs in full blossom",
            "🌻 Glamoč: Linden trees producing fragrant honey",
            "🌿 Kupres: Alpine pastures full of wildflowers",
            "🍯 Čapljina: Citrus blossoms boosting honey aroma",
            "🌸 Posušje: Sage and thyme thriving on karst soils",
            "🍃 Livno: Wide meadows perfect for meadow honey",
            "🌿 Grude: Medicinal herbs in bloom attract bees",
            "🌻 Široki Brijeg: Lavender and clover fields in bloom",
            "🍯 Jajce: Mountain herbs creating rich honey flavors",
            "🌸 Rudo: Clean environment ideal for wildflower honey"
          ],
          "Preview Mode": "Preview Mode:",
          "Sign up to see all →": "Sign up to see all →",
          "Get Weekly Map Recommendations Based on Real Data": "Get weekly map recommendations based on real data",
          "Each week, we analyze weather, blooming timing, and more — so you know exactly where to place your hives.":
            "Each week, we analyze weather, blooming timing, and more — so you know exactly where to place your hives.",
          "Optimal Locations Map": "Optimal Locations Map",
          "Location Info": "Location Info",
          "Weather Data": "Weather Data",
          "Top 5 Cities": "Top 5 Cities",
          "Why HoneyScout Changes Everything": "Why HoneyScout Changes Everything",
          "Why Now?": "Why Now?",
          "Climate patterns are shifting - traditional spots may no longer be optimal":
            "Climate patterns are shifting - traditional spots may no longer be optimal",
          "AI-powered analysis gives you the competitive edge in honey production":
            "AI-powered analysis gives you the competitive edge in honey production",
          "Real-time data prevents costly mistakes and maximizes your investment":
            "Real-time data prevents costly mistakes and maximizes your investment",
          "How It's Implemented": "How It's Implemented",
          "Real-time Weather Analysis": "Real-time Weather Analysis",
          "Advanced meteorological data processing for precise forecasts":
            "Advanced meteorological data processing for precise forecasts",
          "Blooming Pattern Recognition": "Blooming Pattern Recognition",
          "AI identifies optimal flowering cycles across regions":
            "AI identifies optimal flowering cycles across regions",
          "Smart Location Scoring": "Smart Location Scoring",
          "Multi-factor algorithm ranks best placement opportunities":
            "Multi-factor algorithm ranks best placement opportunities",
          "HoneyScout": "HoneyScout",
          "Your AI-Powered Beekeeping Companion": "Your AI-Powered Beekeeping Companion",
          "Recommendation": "Recommendations",
          "Login with Email": "Login with Email",
          "Please enter valid email!": "Please enter valid email!",
          "Please enter email!": "Please enter email!",
          "Error sending verification email.": "Error sending verification email.",
          "Verification email sent! Please check your inbox.": "Verification email sent! Please check your inbox.",
          "Welcome": "Welcome",
          "Honeyscout — This week's new prediction.": "Honeyscout — This week's new prediction.",
          "Bosnia": "Bosnia",
          "Croatia": "Croatia",
          "Serbia": "Serbia",
          "Top 5 in": "Top 5 in",
          "Image of the weather": "Image of the weather",
          "Temperature": "Temperature",
          "clear sky": "Clear sky",
          "few clouds": "Few clouds",
          "scattered clouds": "Scattered clouds",
          "broken clouds": "Broken clouds",
          "shower rain": "Shower rain",
          "rain": "Rain",
          "thunderstorm": "Thunderstorm",
          "snow": "Snow",
          "mist": "Mist",
          "overcast clouds": "Overcast clouds",
          "light rain": "Light rain",
          "moderate rain": "Moderate rain",
          "heavy intensity rain": "Heavy intensity rain",
          "light snow": "Light snow",
          "heavy snow": "Heavy snow",
          "sleet": "Sleet",
          "fog": "Fog",
          "haze": "Haze",
          "Top 3 Plants Blooming": "Top 3 Plants Blooming",
          "Log out": "Log out",
          "Register": "Register",
          "Log in": "Log in",
          "Email": "Email",
          "Password": "Password",
          "Already have an account?": "Already have an account?",
          "Don't have an account?": "Don't have an account?",
          "Registration successful! Redirecting to login...": "Registration successful! Redirecting to login...",
          "Login failed": "Login failed",
          "Failed to register": "Failed to register",
          "Select a location to view blooming data": "Select a location to view blooming data",
          "Select a location to view weather data": "Select a location to view weather data",
          "Chestnut": "Chestnut",
          "Goldenrod": "Goldenrod",
          "Heather": "Heather",
          "Rosemary": "Rosemary",
          "Lavender": "Lavender",
          "Wild Thyme": "Wild Thyme",
          "Ivy": "Ivy",
          "Sage": "Sage",
          "Dandelion": "Dandelion",
          "Linden": "Linden",
          "Clover": "Clover",
          "Sunflower": "Sunflower",
          "Buckwheat": "Buckwheat",
          "Acacia": "Acacia",
          "Wind": "Wind",
          "Rain": "Rain",
          "Wildflowers": "Wildflowers",
          "Meadow Plants": "Meadow plants",
          "Thyme": "Thyme",
          "Raspberry": "Raspberry",
          "Daisy": "Daisy",
          "Beech": "Beech",
          "Spruce": "Spruce",
          "Fir": "Fir",
          "Pine": "Pine",
          "Wild Mint": "Wild Mint",
          "Rapeseed": "Rapeseed",
          "Current": "Current",
          "Weather": "Weather",
          "Satellite Metrics": "Satellite Metrics",
          "NDVI": "NDVI",
          "Soil Moisture": "Soil Moisture",
          "Land Surface Temp (°C)": "Land Surface Temp (°C)",
          "Land Cover Type": "Land Cover Type",
          "Select a location to view satellite metrics": "Select a location to view satellite metrics",
          "Yarrow": "Yarrow",
          "From": "from",
          "To": "to",
          "Weather Forecast": "Weather Forecast",
          "Select a location to view the forecast": "Select a location to view the forecast",
          "Top 3 Locations": "Top 3 Locations",
          "Land Surface Temp": "Land Surface Temp",
          "7-Day Forecast": "7-Day Forecast",
          "Current Weather": "Current Weather",
          "Wind Speed": "Wind Speed",
          "Humidity": "Humidity",
          "Plants in Bloom": "Plants in Bloom",
          "Welcome back": "Welcome back",
          "Best locations for beekeeping": "Best locations for beekeeping",
          "Real-time data": "Real-time data",
          "Weather forecast for selected location": "Weather forecast for selected location",
          "Current weather conditions": "Current weather conditions",
          "Detailed weather information": "Detailed weather information",
          "Currently blooming": "Currently blooming",
          "Active blooming": "Active blooming",
          "Excellent": "Excellent",
          "Medium": "Medium",
          "Low": "Low",
          "Lowest temp": "Lowest temperature",
          "Highest temp": "Highest temperature",
          "mm = rainfall": "mm = rainfall",
          "Monday": "Monday",
          "Tuesday": "Tuesday",
          "Wednesday": "Wednesday",
          "Thursday": "Thursday",
          "Friday": "Friday",
          "Saturday": "Saturday",
          "Sunday": "Sunday",
          "Mon": "Mon",
          "Tue": "Tue",
          "Wed": "Wed",
          "Thu": "Thu",
          "Fri": "Fri",
          "Sat": "Sat",
          "Sun": "Sun",
          "NDVI Explanation": "Vegetation index: 0 and below = no vegetation, 1 = lush vegetation",
          "Soil Moisture Explanation": "Soil moisture index: lower values = drier, higher values = wetter",
          "Land Surface Temp Explanation": "Land surface temperature: different from air temperature",
          "Land Cover Explanation": "Land type: forest, agricultural, urban, water, etc.",
          "Learn more": "Learn more",
          "Real-time satellite data for vegetation, soil, and land conditions": "Real-time satellite data for vegetation, soil, and land conditions",
          "bagrem": "Acacia",
          "livada": "Meadow",
          "kadulja": "Sage",
          "draca": "Hawthorn",
          "kesten": "Chestnut",
          "BiH": "Bosnia & Herzegovina",
          "Srbija": "Serbia",
          "Hrvatska": "Croatia",
          "Zone radius": "Zone radius",
          "Filter Locations": "Filter Locations",
          "Choose view type": "Choose view type",
          "Zones": "Zones",
          "locations found": "locations found",
          "No zones found for this plant": "No zones found for this plant",
          "Odlična aktivnost": "Excellent activity",
          "Dobra aktivnost": "Good activity",
          "Umjerena aktivnost": "Moderate activity",
          "Slaba aktivnost": "Low activity",
          "Nema aktivnosti": "No activity",
          "Noćni mir": "Night rest",
          "Idealni uvjeti za pčele": "Ideal conditions for bees",
          "Pčele rade normalno": "Bees working normally",
          "Smanjen izlazak": "Reduced foraging",
          "Loši vremenski uvjeti": "Poor weather conditions",
          "Pčele u košnici": "Bees in hive",
          "Pčele spavaju": "Bees sleeping",
          "Aktivnost pčela": "Bee activity",
          "vjetar": "wind",
          "Odaberi lokaciju za procjenu": "Select a location to estimate",
          "Odaberi lokaciju na mapi": "Select a location on the map",
          "Uslovi za pčele": "Bee Conditions",
          "Odlični uslovi": "Excellent Conditions",
          "Dobri uslovi": "Good Conditions",
          "Umjereni uslovi": "Moderate Conditions",
          "Loši uslovi": "Poor Conditions",
          "Vrlo loši uslovi": "Very Poor Conditions",
          "Noćni uslovi": "Night Conditions",
          "Idealan period za pčele": "Ideal period for bees",
          "Pčele aktivne i produktivne": "Bees active and productive",
          "Ograničena aktivnost": "Limited activity",
          "Nepovoljno za pčele": "Unfavorable for bees",
          "Pčele ostaju u košnici": "Bees stay in hive",
          "Pčele miruju": "Bees resting",
          "Vremenski uslovi za pčele": "Weather conditions for bees",
          "BeeCare": "BeeCare",
          "Pratite košnicu uživo": "Track your hive live",
          "Pametna vaga za pčelare": "Smart scale for beekeepers",
          "BeeCare digitalni sistemi za pčelarstvo": "BeeCare digital systems for beekeeping",
          "Želite pratiti stanje svojih košnica u realnom vremenu?":
          "Do you want to track the condition of your hives in real time?",
          "Kliknite i naručite": "Click and order the",
          "Naruči": "ORDER",
          "Scale!": "scale!",
          "ZA PČELARSTVO": "FOR BEEKEEPING",
          "DIGITALNI SISTEMI": "DIGITAL SYSTEMS",
          "Znate li koliko vaša košnica zaista vrijedi? BeeCare pametna vaga mjeri težinu, temperaturu i vlagu — 24/7, direktno na vašem telefonu.":
          "Do you know how much your hive is really worth? The BeeCare smart scale measures weight, temperature, and humidity — 24/7, directly on your phone."
        }
      }
    },
    fallbackLng: "en",
    interpolation: { escapeValue: false }
  });

export default i18n;
